import { render, staticRenderFns } from "./NewsImagePreview.vue?vue&type=template&id=4193d050"
import script from "./NewsImagePreview.js?vue&type=script&lang=js&external"
export * from "./NewsImagePreview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports